const SENSITIVE_KEY_PATTERNS = [
  /token/i,
  /secret/i,
  /password/i,
  /authorization/i,
  /cookie/i,
  /api[-_]?key/i,
  /service[-_]?role/i,
  /access[-_]?token/i,
  /refresh[-_]?token/i,
];

const REDACTED = "[REDACTED]";
const CIRCULAR = "[Circular]";

function isSensitiveKey(key: string) {
  return SENSITIVE_KEY_PATTERNS.some((pattern) => pattern.test(key));
}

function sanitizeValue(value: unknown, seen: WeakSet<object>): unknown {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
    };
  }

  if (value === null || typeof value !== "object") {
    return value;
  }

  if (seen.has(value)) {
    return CIRCULAR;
  }

  seen.add(value);

  if (Array.isArray(value)) {
    return value.map((item) => sanitizeValue(item, seen));
  }

  return Object.fromEntries(
    Object.entries(value as Record<string, unknown>).map(([key, entry]) => [
      key,
      isSensitiveKey(key) ? REDACTED : sanitizeValue(entry, seen),
    ]),
  );
}

export function sanitizeForTelemetry(value: unknown): unknown {
  return sanitizeValue(value, new WeakSet<object>());
}

export { REDACTED };
